import { GoldenRecordExchangeConfigDto } from './dto/GoldenRecordExchangeConfigDto';
import { IsString } from 'class-validator';

export class GoldenRecordExchangeConfig extends GoldenRecordExchangeConfigDto {
  @IsString()
  collection: string;
}
